import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=4e7e7d56&"
import script from "./PageHeader.vue?vue&type=script&lang=tsx&"
export * from "./PageHeader.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports